import {
	CreateDrawerFormProps,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	FormFetchDrawer,
	TextField,
	UpdateDrawerFormProps,
} from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { campaignService } from "../shared/api/campaignService";
import { ICampaignIndexResource, ICampaignRequest } from "../shared/types";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: ICampaignRequest) => {
		const errors: { [K in keyof ICampaignRequest]?: any } = {};

		if (!values.name) {
			errors.name = t("Required field");
		}
		return errors;
	};
};

const CampaignFormDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<TextField name="name" label={t("Name")} required />
		</FormDrawerContent>
	);
};

export const CampaignCreateDrawer: FC<CreateDrawerFormProps<ICampaignRequest>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();
	const initialValues: ICampaignRequest = { name: "" };

	return (
		<FormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Create campaign")}
			validate={validate}
			renderForm={(props) => <CampaignFormDrawerContent {...props} />}
		/>
	);
};

export const CampaignUpdateDrawer: FC<UpdateDrawerFormProps<ICampaignIndexResource>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormFetchDrawer
			{...props}
			title={t("Edit campaign")}
			queryFn={() => campaignService.show(props.id).then((x) => x.data.data)}
			queryKey={campaignService.showKey(props.id)}
			validate={validate}
			renderSuccess={(props) => <CampaignFormDrawerContent {...props} />}
		/>
	);
};
